import { CatalogGrid } from "./Catalog";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Searchresult from "./search";
import Api_key from "./apiconfiguration";
import LoadingScreen from "./LoadingScreen";

const Air = ({ search }) => {
  const [airingToday, setAiringToday] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiKey = Api_key;

  useEffect(() => {
    const fetchAiringToday = async () => {
      try {
        const airingTodayEndpoint = `https://api.themoviedb.org/3/movie/now_playing?language=en-US&region=US&api_key=${apiKey}`;
        
        const responses = await Promise.all([    
          axios.get(`${airingTodayEndpoint}&page=1`),
          axios.get(`${airingTodayEndpoint}&page=2`),
          axios.get(`${airingTodayEndpoint}&page=3`),
          axios.get(`${airingTodayEndpoint}&page=4`),
          axios.get(`${airingTodayEndpoint}&page=5`),
          axios.get(`${airingTodayEndpoint}&page=6`),
          axios.get(`${airingTodayEndpoint}&page=7`),
          axios.get(`${airingTodayEndpoint}&page=8`),
        ]);

        const combinedShows = responses.flatMap(response => response.data.results);

        setAiringToday(combinedShows.slice(0, 120));
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchAiringToday();
  }, []);


  if (error) return <p>Error loading movies: {error}</p>;
  if (loading) return <LoadingScreen label="Checking what’s playing now" />;

  return (
    <>
      {search ? (
        <Searchresult search={search} />
      ) : (
          <CatalogGrid items={airingToday.slice(0, 60)} title="Now on the big screen." description="The latest releases, ready for your next movie night." eyebrow="IN THEATERS" />
      )}
    </>
  );
};

export default Air;
